// import AirDatepicker from 'air-datepicker';
// import localeEn from 'air-datepicker/locale/en';

export default class Datepickers {
	constructor(checkIn, checkOut) {
		if (!checkIn || ! checkOut) return;

		let checkInPicker, checkOutPicker;

		checkInPicker = new AirDatepicker(checkIn, {
			dateFormat: 'dd-MM-yyyy',
			keyboardNav: false,
			locale: localeEn,
			autoClose: true,
			buttons: ['clear'],
			onSelect({date}) {
				checkOutPicker.update({
					minDate: date
				});
			}
		});

		checkOutPicker = new AirDatepicker(checkOut, {
			dateFormat: 'dd-MM-yyyy',
			keyboardNav: false,
			locale: localeEn,
			autoClose: true,
			buttons: ['clear'],
			onSelect({date}) {
				checkInPicker.update({
					maxDate: date
				});
			}
		});

	}
}
